import { render, staticRenderFns } from "./BtnJustificativaAlteracaoRateio.vue?vue&type=template&id=709bb3ff"
import script from "./BtnJustificativaAlteracaoRateio.vue?vue&type=script&lang=js"
export * from "./BtnJustificativaAlteracaoRateio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports